import './featured-card.scss';

import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
import { defineComponent } from 'vue';

import { Touchable } from '../touchable';

export enum States {
    ABORTED = 'aborted',
    PENDING = 'pending',
    READY = 'ready',
}

export enum ActionType {
    EDIT,
}

export interface TitleClickAction {
    action: ActionType
    targetRouteName: string
}

export const FeaturedCard = defineComponent({
    components: {
        sTouchable: Touchable,
    },
    props: {
        featured: {},
        rounded: {
            type: Boolean,
        },
        showDates: {
            type: Boolean,
            default: true,
        }
    },
    template: require('./featured-card.html'),
    data() {
        return {
            circleIcon: faDotCircle,
            state: States.PENDING,
        }
    },
    methods: {
        isReady() {
            return this.state === States.READY;
        },
    },
    watch: {
        featured: {
            handler(featured) {
                this.state = featured ? States.READY : States.PENDING;
            },
            immediate: true,
            deep: true,
        },
    },
})
